export type CachePersistenceFailureAction = {
  /** Send the underlying error to the log sink so the cause is diagnosable. */
  log: boolean;
  /** Show the operator a toast. */
  toast: boolean;
};

export type CachePersistenceFailureInput = {
  /**
   * Whether the app actually depends on the persisted react-query cache to keep
   * working without a connection. For online-only apps (Checkd, Manager, Dashd)
   * the cache is only a warm-start optimisation — a failure costs a refetch the
   * operator never notices, so it must not raise an error toast.
   */
  offlineCapable: boolean;
  /** Whether a failure has already been acted on for this provider mount. */
  hasReported: boolean;
};

/**
 * Decide what to do when writing/reading the react-query cache in IndexedDB fails.
 *
 * Persistence runs on *every* query- and mutation-cache event, so a hard failure
 * (private mode, quota exhausted, partitioned storage in an embedded iframe)
 * repeats for the whole session. One report per mount carries the diagnosis;
 * everything after it is flood — in the log sink and on screen alike.
 */
export const resolveCachePersistenceFailureAction = ({
  offlineCapable,
  hasReported,
}: CachePersistenceFailureInput): CachePersistenceFailureAction => ({
  log: !hasReported,
  toast: offlineCapable && !hasReported,
});
